// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        :host{
             --width: fit-content !important;
        }
        
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBvcG92ZXIuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7UUFDUTthQUNLLCtCQUErQjtRQUNwQyIsImZpbGUiOiJwb3BvdmVyLmNvbXBvbmVudC50cyIsInNvdXJjZXNDb250ZW50IjpbIlxuICAgICAgICA6aG9zdHtcbiAgICAgICAgICAgICAtLXdpZHRoOiBmaXQtY29udGVudCAhaW1wb3J0YW50O1xuICAgICAgICB9XG4gICAgICAgICJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/pickdate/popover/popover.component.ts"],"names":[],"mappings":";QACQ;aACK,+BAA+B;QACpC;;AAER,4WAA4W","sourcesContent":["\n        :host{\n             --width: fit-content !important;\n        }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
